import { render, staticRenderFns } from "./PcmsoTable.vue?vue&type=template&id=45992cb5&scoped=true&"
import script from "./PcmsoTable.vue?vue&type=script&lang=js&"
export * from "./PcmsoTable.vue?vue&type=script&lang=js&"
import style0 from "./PcmsoTable.vue?vue&type=style&index=0&id=45992cb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45992cb5",
  null
  
)

export default component.exports